import { Component, Input } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { ServiceFinishing } from 'src/app/shared/models/entities/service';

@Component({
  selector: 'laveo-select-service-finishing',
  templateUrl: './select-service-finishing.component.html',
  styleUrls: ['./select-service-finishing.component.scss']
})
export class SelectServiceFinishingComponent {
  @Input() control: AbstractControl | null;
  @Input() typeSize: 'default' | 'small' | 'large' = 'large';
  @Input() values: ServiceFinishing[] = Object.values(ServiceFinishing);

  public get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }
}
